import React from "react";

function ComplianceReport () {
    return (
        <h1>Reporte de Cumplimiento</h1>
    )
};

export default ComplianceReport;